import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Apaleo**
 *
 * @exports bs_402
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let priceUpdate;

  /**
     * @memberOf module:bs_402
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    const isLogged = !document.querySelector('.ibe-login-link');

    return isLogged;
  };

  /**
   * @memberOf module:bs_402
   * @see {@link onStateChange}
   *
   * @param {object} ctx - The context object.
   */
  engine.onStateChange = function onStateChange(ctx) {
    setTimeout(thn.pageCheck, 800);
  };

  /**
   * @memberOf module:bs_402
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/\/book/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
   * @memberOf module:bs_402
   * @this thn.widgets.price
   * @see {@link Price#observe_dom}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const container = document.querySelector('.ibe-room-results-list');
    if (container && !priceUpdate) {
      priceUpdate = thn.debounce(() => ctx.widget.refresh(), 500);
      thn.observeDom(container, priceUpdate, {
        childList: true,
        subTree: true,
      });

      thn.pageUnload(() => {
        priceUpdate.cancel();
        thn.stopObserveDom(container, priceUpdate);
        priceUpdate = null;
      });
    }
    const dataLayer = window.dataLayer;
    const shouldAvoidDataLayerOberverUsers = [1044170].includes(thn.data.accountUerId);

    if (!thn.apaleoPriceObserver && dataLayer && !shouldAvoidDataLayerOberverUsers) {

      thn.apaleoPriceObserver = new thn.DataLayerHelper(window.dataLayer, function (model, message) {

        if (message.event === 'showRooms') {
          setTimeout(() => ctx.widget.refresh(), 400);
        }
      }, true);

      thn.pageUnload(function () {
        thn.apaleoPriceObserver.cancel();
        delete thn.apaleoPriceObserver;
      });
    }
  };

  /**
     * @memberOf module:bs_402
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const dataLayerSearchData = thn.dataLayerHelper.get('up') || thn.objectGet(window.dataLayer, 'up', { first: false });

    // Dates
    widgetData.dateBegin = dataLayerSearchData?.arrivalDate?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3') || (thn.dataLayerHelper.get('arrivalDate') || thn.parseUrlParameter('arrival'))?.replace(/-/g, '/');
    widgetData.dateEnd = dataLayerSearchData?.departureDate?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3') || (thn.dataLayerHelper.get('departureDate') || thn.parseUrlParameter('departure'))?.replace(/-/g, '/');

    // Guests, Adults & Children
    widgetData.adults = thn.parseNumber(dataLayerSearchData?.numberOfGuests) || 2;
    widgetData.children = thn.parseNumber(dataLayerSearchData?.children) || 0;

    // No availability
    const noAvailability = !!document.querySelector('.ibe-no-room-results-text');

    // Prices & Currency || No Rooms
    const currency = dataLayerSearchData?.lowestPrice?.currency;
    const price = thn.parseNumber(dataLayerSearchData?.lowestPrice?.amount);
    if (!noAvailability) {
      widgetData.currency = currency;
      widgetData.price = price;
      widgetData.set = true;
      widgetData.roomDetails = engine._roomDetailsParseData(widgetData.adults);
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
        *
        * @memberOf module:bs_402
        *
        */
  engine._roomDetailsParseData = function roomDetailsParseData(adults) {
    const container = [...document.querySelectorAll('.ibe-room-result')];

    if (thn.empty(container)) {
      return {};
    }

    const roomsInfo = container.map((room) => {

      const roomName = room.querySelector('.ibe-room-title')?.textContent;
      const roomType = getRoomType(roomName);
      const prices = [...room.querySelectorAll('.ibe-rate-option-left')].map((price) => {
        const rateName = price.querySelector('.ibe-rate-title')?.textContent?.split('|')[1]?.trim();
        const totalPrice = thn.parseNumber(price.querySelector('.ng-star-inserted')?.textContent);
        return {
          id: '',
          name: rateName,
          totalNight: totalPrice,
          breakfast: !!rateName.match(/Breakfast|breakfast/),
          refundable: !rateName.match(/Advance|advance/),
        };
      });
      return {
        id: '',
        name: roomName,
        adults: adults || 2,
        children: 0,
        type: roomType,
        prices: prices,
      };
    });

    return roomsInfo;

  };

  /**
     * @memberOf module:bs_402
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    const dataLayer = window.dataLayer;

    if (!thn.apaleoBookingObserver && dataLayer) {
    // Create function to delete observer whenever we want
      const stop = function () {
        thn.apaleoBookingObserver?.cancel();
        delete thn.apaleoBookingObserver;
      };

      thn.apaleoBookingObserver = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
        if (message.event === 'completedReservation' && ctx.widget.setData().isSet()) {
          ctx.widget.save();
          stop();
        }
      }, true);

      thn.pageUnload(stop);
    }
  };

  /**
     * @memberOf module:bs_402
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const datalayerInfo = thn.dataLayerHelper.get('ecommerce')?.purchase;

    // Booking_ID
    const bookingId = datalayerInfo?.actionField?.upBookingIds?.[0]
                    || document.querySelector('.ibe-booking-id')?.textContent
                    || thn.objectGet(window.dataLayer, 'confirmationNumber', { first: false })
                    || thn.objectGet(window.dataLayer, 'reservationId', { first: false });

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    const adults = [...document.querySelectorAll('.ibe-adults')];

    if (datalayerInfo.products.length > 1) {

      const widgetDataMulti = datalayerInfo.products.map((el, index) => {
        const data = {
          dateBegin: el.upArrival.replace(/-/g, '/'),
          dateEnd: el.upDeparture.replace(/-/g, '/'),
          price: el.price,
          currency: datalayerInfo?.actionField?.upCurrency,
          bookingId: `${bookingId}-${index + 1}`,
          adults: thn.parseNumber(adults[index]?.textContent),
        };
        return data;
      });

      if (!thn.empty(widgetDataMulti)) {
        return widgetDataMulti;
      }

    }

    widgetData.bookingId = bookingId;
    // Guests

    widgetData.adults = thn.parseNumber(adults?.[0]?.textContent) || thn.objectGet(window.dataLayer, 'numOfAdults', { first: false });
    widgetData.children = thn.objectGet(window.dataLayer, 'numOfChildren', { first: false });

    // Dates
    widgetData.dateBegin = (datalayerInfo?.products?.[0]?.upArrival || thn.objectGet(window.dataLayer, 'arrivalDate', { first: false }))?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
    widgetData.dateEnd = (datalayerInfo?.products?.[0]?.upDeparture || thn.objectGet(window.dataLayer, 'departureDate', { first: false }))?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');

    // Price & Currency
    widgetData.price = datalayerInfo?.actionField?.revenue || thn.parseNumber(document.querySelector('.ibe-total-cost-value')?.textContent) || thn.objectGet(window.dataLayer, 'revenue', { first: false });
    widgetData.currency = datalayerInfo?.actionField?.upCurrency || thn.parseCurrency(document.querySelector('.ibe-total-cost-value')?.textContent) || thn.objectGet(window.dataLayer, 'currency', { first: false });

    return widgetData;
  };

  return engine;

}

export { factory };
